import domReady from '@wordpress/dom-ready';
import { createRoot, render, useState } from '@wordpress/element';
import Lightbox from 'react-awesome-lightbox';

const App = ( { attributes } ) => {
	const { images } = attributes;
	const [ urls, setUrls ] = useState( [] );
	const settings = {
		allowRotate: false,
		allowReset: false,
		keyboardInteraction: false,
		doubleClickZoom: 0,
	};

	const handleClick = ( displayImg ) => {
		if ( images.length === 1 ) {
			setUrls( [ { ...displayImg } ] );
		} else if ( images.length > 1 ) {
			setUrls( images );
		}
	};

	return (
		<>
			{ images.map( ( image ) => (
				// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
				<img
					key={ image.id }
					src={ image.url }
					alt={ image.alt }
					onClick={ () => handleClick( image ) }
				/>
			) ) }

			{ urls.length >= 1 && (
				<Lightbox
					image={ urls[ 0 ].url }
					{ ...settings }
					onClose={ () => setUrls( [] ) }
				/>
			) }

			{ urls.length > 1 && (
				<Lightbox
					images={ urls }
					{ ...settings }
					onClose={ () => setUrls( [] ) }
				/>
			) }
		</>
	);
};

domReady( () => {
	const mountWrap = document.querySelectorAll(
		'.wp-block-do-blocks-image-lightbox'
	);
	const mountWrapArr = Array.from( mountWrap );

	mountWrapArr.forEach( ( item ) => {
		if ( createRoot ) {
			createRoot( item ).render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>
			);
		} else {
			render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>,
				item
			);
		}
	} );
} );
